import { useEffect } from 'react';
import type { AnyAction, Dispatch } from 'redux';
import { kebabCase } from '@makemydeal/dr-common-utils';
import * as dealScreenErrorActionCreators from '@makemydeal/dr-dash-store/actions/dealScreenErrorActionCreators';
import { DealTabs } from '@makemydeal/dr-shared-types';
import { convertToNumber } from '../../../utils/formatUtils';
import type { StateTree } from '@makemydeal/dr-dash-types';

interface UseFieldValidationEffectParams {
    isEnabled: boolean;
    dispatch: Dispatch<AnyAction, StateTree>;
    failed: boolean;
    value: string;
    threshold: number;
    validationError: boolean;
    fieldName: string;
}

export function useFieldValidationEffect({
    isEnabled,
    dispatch,
    failed,
    value,
    threshold,
    validationError,
    fieldName
}: UseFieldValidationEffectParams) {
    useEffect(() => {
        if (isEnabled) {
            const maxValueError = convertToNumber(value) > threshold;
            const hasError = maxValueError || failed;
            if (hasError !== validationError) {
                dispatch(dealScreenErrorActionCreators.setFieldError(DealTabs.SUMMARY, kebabCase(fieldName), hasError));
            }
        }
    }, [isEnabled, dispatch, failed, value]);
}
